import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import _toConsumableArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2;

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import DPServices from "@dp/services";
import { makeObservable, observable, reaction, runInAction } from "mobx";
import { CartModel } from ".";
import Base from "./Base";
import OrderConfirmationModel from "./models/OrderConfirmationModel";
import BreadSticksModel from "./models/BreadSticksModel";
import { DecodedOrderType, PlatformType } from "@dp/common";
import moment from "moment";
import Errors, { ERROR_STRINGS } from "./Errors";
import i18next from "i18next";
import { ORDER_TYPES } from "@dp/common";
var OrderConfirmation = (_class = /*#__PURE__*/function (_Base) {
  _inherits(OrderConfirmation, _Base);

  var _super = _createSuper(OrderConfirmation);

  function OrderConfirmation(rootStore) {
    var _this;

    _classCallCheck(this, OrderConfirmation);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "rootStore", void 0);

    _defineProperty(_assertThisInitialized(_this), "orderConfirmationModel", null);

    _defineProperty(_assertThisInitialized(_this), "breadSticksModel", null);

    _defineProperty(_assertThisInitialized(_this), "cartModel", null);

    _initializerDefineProperty(_assertThisInitialized(_this), "_restuarantDetails", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_sessionDetails", _descriptor2, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "analyticsModel", void 0);

    _this.rootStore = rootStore;
    var platformUtil = _this.rootStore.platformUtil;
    _this.orderConfirmationModel = new OrderConfirmationModel(platformUtil);
    _this.cartModel = new CartModel(platformUtil);
    _this.breadSticksModel = new BreadSticksModel();
    makeObservable(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(OrderConfirmation, [{
    key: "_processSessionDetails",
    value: function _processSessionDetails(session) {
      var _this2 = this;

      this.cartModel.setSessionDetails(session);
      this.orderConfirmationModel.setSessionDetails(session);
      runInAction(function () {
        _this2._sessionDetails = session;
      });
    }
  }, {
    key: "_processAppAttributes",
    value: function () {
      var _processAppAttributes2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(appAttributes) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.cartModel.setAppAttributesData(appAttributes);
                this.orderConfirmationModel.setAppAttributes(appAttributes);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _processAppAttributes(_x) {
        return _processAppAttributes2.apply(this, arguments);
      }

      return _processAppAttributes;
    }()
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this$rootStore,
            _this$rootStore$user,
            _this$rootStore2,
            _this$rootStore2$rest,
            _this3 = this;

        var restaurantDetail;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.analyticsModel = (_this$rootStore = this.rootStore) === null || _this$rootStore === void 0 ? void 0 : (_this$rootStore$user = _this$rootStore.user) === null || _this$rootStore$user === void 0 ? void 0 : _this$rootStore$user.analyticsModel;

                this._processSessionDetails(this.rootStore.user.sessionDetails);

                _context2.next = 4;
                return this._processAppAttributes(this.rootStore.common.appAttributes);

              case 4:
                restaurantDetail = (_this$rootStore2 = this.rootStore) === null || _this$rootStore2 === void 0 ? void 0 : (_this$rootStore2$rest = _this$rootStore2.restaurant) === null || _this$rootStore2$rest === void 0 ? void 0 : _this$rootStore2$rest.detail;
                runInAction(function () {
                  _this3._restuarantDetails = restaurantDetail;

                  _this3.analyticsModel.setRestaurantDetailData(restaurantDetail);

                  _this3.orderConfirmationModel.setRestaurantDetailData(restaurantDetail);
                });

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", Promise.resolve());

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", Promise.resolve());

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "setupReactions",
    value: function setupReactions() {
      var _this4 = this; //session-details


      reaction(function () {
        var _this4$rootStore, _this4$rootStore$rest;

        return {
          detail: (_this4$rootStore = _this4.rootStore) === null || _this4$rootStore === void 0 ? void 0 : (_this4$rootStore$rest = _this4$rootStore.restaurant) === null || _this4$rootStore$rest === void 0 ? void 0 : _this4$rootStore$rest.detail
        };
      }, /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(data) {
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _this4._restuarantDetails = data === null || data === void 0 ? void 0 : data.detail;

                  _this4.orderConfirmationModel.setRestaurantDetailData(data === null || data === void 0 ? void 0 : data.detail);

                case 2:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }());
      reaction(function () {
        return {
          sessionDetails: _this4.rootStore.user.sessionDetails
        };
      }, function (data) {
        _this4._processSessionDetails(data.sessionDetails);
      });
    }
  }, {
    key: "redirectToMenuPage",
    value: function () {
      var _redirectToMenuPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.rootStore.refreshInProgress = true;

                if (this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP) {
                  this.rootStore.platformUtil.navigateToRoute("/menu");
                } else this.rootStore.platformUtil.redirectToURL("/menu");

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function redirectToMenuPage() {
        return _redirectToMenuPage.apply(this, arguments);
      }

      return redirectToMenuPage;
    }()
  }, {
    key: "getLastOrderData",
    value: function () {
      var _getLastOrderData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(orderId) {
        var _lastOrder$order,
            _lastOrder$order$pric,
            _this5 = this;

        var jwtToken, lastOrder, _lastOrder$order2, _lastOrder$order3, _this$rootStore3, _this$rootStore3$user, _lastOrder$order4, _this$orderConfirmati;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (orderId) {
                  _context7.next = 3;
                  break;
                }

                this.redirectToMenuPage();
                return _context7.abrupt("return");

              case 3:
                _context7.next = 5;
                return this.rootStore.user.getTokenSilentIfLoggedIn();

              case 5:
                jwtToken = _context7.sent;
                _context7.next = 8;
                return DPServices.Confirmation.getLastOrder(orderId, jwtToken);

              case 8:
                lastOrder = _context7.sent;

                if (!(lastOrder && Object.keys(lastOrder).length > 0 && !!(lastOrder !== null && lastOrder !== void 0 && (_lastOrder$order = lastOrder.order) !== null && _lastOrder$order !== void 0 && (_lastOrder$order$pric = _lastOrder$order.priceInfo) !== null && _lastOrder$order$pric !== void 0 && _lastOrder$order$pric.amount))) {
                  _context7.next = 19;
                  break;
                }

                this.analyticsModel.setLastOrderDetails(lastOrder);
                this.orderConfirmationModel.setLastOrderData(lastOrder);
                this.setCartItems(lastOrder === null || lastOrder === void 0 ? void 0 : (_lastOrder$order2 = lastOrder.order) === null || _lastOrder$order2 === void 0 ? void 0 : _lastOrder$order2.commerceItems);
                this.breadSticksModel.cartItems = lastOrder === null || lastOrder === void 0 ? void 0 : (_lastOrder$order3 = lastOrder.order) === null || _lastOrder$order3 === void 0 ? void 0 : _lastOrder$order3.commerceItems;

                if (!((_this$rootStore3 = this.rootStore) !== null && _this$rootStore3 !== void 0 && (_this$rootStore3$user = _this$rootStore3.user) !== null && _this$rootStore3$user !== void 0 && _this$rootStore3$user.isLoggedIn)) {
                  this.saveOrderDataInLocalStorage();
                }

                if (this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP) {
                  this.checkAndSaveCurbsideOrderDataInLocalStorage();
                }

                if ((lastOrder === null || lastOrder === void 0 ? void 0 : (_lastOrder$order4 = lastOrder.order) === null || _lastOrder$order4 === void 0 ? void 0 : _lastOrder$order4.orderType) === ORDER_TYPES.TOGO_DELIVERY) {
                  this.analyticsModel.setDeliveryEstimate((_this$orderConfirmati = this.orderConfirmationModel) === null || _this$orderConfirmati === void 0 ? void 0 : _this$orderConfirmati.timeEstimate);
                } // working solution for now. Will be trying to come up with a better solution
                // To ensure digitalData updates before firing the event.


                setTimeout(function () {
                  var _lastOrder$order5, _lastOrder$order6, _lastOrder$order7;

                  _this5.orderConfirmEvent(lastOrder === null || lastOrder === void 0 ? void 0 : (_lastOrder$order5 = lastOrder.order) === null || _lastOrder$order5 === void 0 ? void 0 : _lastOrder$order5.orderId, lastOrder === null || lastOrder === void 0 ? void 0 : (_lastOrder$order6 = lastOrder.order) === null || _lastOrder$order6 === void 0 ? void 0 : _lastOrder$order6.restaurantId, lastOrder === null || lastOrder === void 0 ? void 0 : (_lastOrder$order7 = lastOrder.order) === null || _lastOrder$order7 === void 0 ? void 0 : _lastOrder$order7.restaurantNum, lastOrder.order.specialInstruction);

                  _this5.analyticsModel.dispatchPurchase();
                }, 0);
                return _context7.abrupt("return");

              case 19:
                this.redirectToMenuPage();

              case 20:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getLastOrderData(_x3) {
        return _getLastOrderData.apply(this, arguments);
      }

      return getLastOrderData;
    }()
  }, {
    key: "setCartItems",
    value: function () {
      var _setCartItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(commerceItems) {
        var cartItems;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                cartItems = this.cartModel.getCartItemsFromCommerceItems(commerceItems);
                this.orderConfirmationModel.setCartItems(cartItems);

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function setCartItems(_x4) {
        return _setCartItems.apply(this, arguments);
      }

      return setCartItems;
    }()
  }, {
    key: "setJoinEClub",
    value: function () {
      var _setJoinEClub = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(email) {
        var signupSource,
            secondarySubscriptions,
            res,
            _this$rootStore4,
            _this$rootStore4$appM,
            _this$rootStore5,
            _this$rootStore5$appM,
            errorUI,
            _this$rootStore$appMe,
            _args9 = arguments;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                signupSource = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : "DARDEN";
                secondarySubscriptions = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : [];
                _context9.prev = 2;
                _context9.next = 5;
                return DPServices.Confirmation.setJoinEClub(email, signupSource, secondarySubscriptions);

              case 5:
                res = _context9.sent;

                if (res !== null && res !== void 0 && res.guestAlreadySubscribed) {
                  (_this$rootStore4 = this.rootStore) === null || _this$rootStore4 === void 0 ? void 0 : (_this$rootStore4$appM = _this$rootStore4.appMessages) === null || _this$rootStore4$appM === void 0 ? void 0 : _this$rootStore4$appM.showError("Error", "You are already subscribed to the eClub.");
                } else {
                  // analytics code
                  this.analyticsModel.processEClubEvent(secondarySubscriptions, signupSource);
                  (_this$rootStore5 = this.rootStore) === null || _this$rootStore5 === void 0 ? void 0 : (_this$rootStore5$appM = _this$rootStore5.appMessages) === null || _this$rootStore5$appM === void 0 ? void 0 : _this$rootStore5$appM.showError("Success", "You have been subscribed to the eClub.");
                }

                return _context9.abrupt("return", res);

              case 10:
                _context9.prev = 10;
                _context9.t0 = _context9["catch"](2);
                errorUI = DPServices.Common.handleUIErrorAndOverride(_context9.t0, {
                  title: ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG,
                  message: Errors.JOIN_ECLUB_FAILED.message
                });

                if (errorUI.errorCode === "EC402") {
                  (_this$rootStore$appMe = this.rootStore.appMessages) === null || _this$rootStore$appMe === void 0 ? void 0 : _this$rootStore$appMe.showError(i18next.t("text.eclub.guest_already_subscribed_popup_heading", {
                    defaultValue: "Great news!"
                  }), i18next.t("text.eclub.guest_already_subscribed_popup_description", {
                    defaultValue: "You are already subscribed to the eClub and should be in on all the latest news, special offers and more"
                  }));
                } else {
                  this.rootStore.appMessages.showError(errorUI.title, errorUI.message, null, {
                    undismissible: true,
                    okBtnText: "Okay"
                  });
                }

              case 14:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[2, 10]]);
      }));

      function setJoinEClub(_x5) {
        return _setJoinEClub.apply(this, arguments);
      }

      return setJoinEClub;
    }()
  }, {
    key: "createAccount",
    value: function () {
      var _createAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(args) {
        var res, _args$dobYear, _this$_sessionDetails, _this$_sessionDetails2, _this$_sessionDetails3, _this$_sessionDetails4, _this$rootStore$platf, _this$rootStore6, _this$rootStore6$appM, _res$data;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return DPServices.Confirmation.createAccount(args);

              case 2:
                res = _context10.sent;

                if (res.success) {
                  // analytics code
                  this.accountCreationEvent(null, null, "US", args === null || args === void 0 ? void 0 : (_args$dobYear = args.dobYear) === null || _args$dobYear === void 0 ? void 0 : _args$dobYear.toString(), this === null || this === void 0 ? void 0 : (_this$_sessionDetails = this._sessionDetails) === null || _this$_sessionDetails === void 0 ? void 0 : (_this$_sessionDetails2 = _this$_sessionDetails.restaurantDetails) === null || _this$_sessionDetails2 === void 0 ? void 0 : _this$_sessionDetails2.restaurantId, this === null || this === void 0 ? void 0 : (_this$_sessionDetails3 = this._sessionDetails) === null || _this$_sessionDetails3 === void 0 ? void 0 : (_this$_sessionDetails4 = _this$_sessionDetails3.restaurantDetails) === null || _this$_sessionDetails4 === void 0 ? void 0 : _this$_sessionDetails4.restaurantNumber);
                  (_this$rootStore$platf = this.rootStore.platformUtil) === null || _this$rootStore$platf === void 0 ? void 0 : _this$rootStore$platf.redirectToURL("/customer-service/recent-activity");
                } else {
                  (_this$rootStore6 = this.rootStore) === null || _this$rootStore6 === void 0 ? void 0 : (_this$rootStore6$appM = _this$rootStore6.appMessages) === null || _this$rootStore6$appM === void 0 ? void 0 : _this$rootStore6$appM.showError("Error", "A user already exists with the login ".concat(res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.login));
                }

                return _context10.abrupt("return", res);

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function createAccount(_x6) {
        return _createAccount.apply(this, arguments);
      }

      return createAccount;
    }()
  }, {
    key: "orderConfirmEvent",
    value: function () {
      var _orderConfirmEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(orderId, restId, restNum, specialInstruction) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                this.analyticsModel.dispatchOrderConfirmation(orderId, restId, restNum, specialInstruction);

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function orderConfirmEvent(_x7, _x8, _x9, _x10) {
        return _orderConfirmEvent.apply(this, arguments);
      }

      return orderConfirmEvent;
    }()
  }, {
    key: "accountCreationEvent",
    value: function () {
      var _accountCreationEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(zipCode, state, country, birthYear, restId, restNum) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                this.analyticsModel.dispatchOrderConfirmationAccCreat(zipCode, state, country, birthYear, restId, restNum);

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function accountCreationEvent(_x11, _x12, _x13, _x14, _x15, _x16) {
        return _accountCreationEvent.apply(this, arguments);
      }

      return accountCreationEvent;
    }() // No need to convert data since now order object is common b/w stores

  }, {
    key: "processLastOrderObject",
    value: function processLastOrderObject() {
      var lastOrder = this.orderConfirmationModel.completeLastOrder;
      return lastOrder;
    }
  }, {
    key: "saveOrderDataInLocalStorage",
    value: function () {
      var _saveOrderDataInLocalStorage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var recentOrderObj, updatedData, storedData, _this$rootStore7, _this$rootStore7$menu, thresholdTimestamp, updatedDataAfterTimeValidation;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                recentOrderObj = this.processLastOrderObject();
                updatedData = []; // changed the key to RECENT_ORDER_DETAILS_CLOUD from RECENT_ORDER_DETAILS
                // to store cloud orders and ignore ATG orders

                _context13.next = 4;
                return this.rootStore.platformUtil.getFromLocalStorage("RECENT_ORDER_DETAILS_CLOUD").then(JSON.parse);

              case 4:
                storedData = _context13.sent;

                if (storedData) {
                  updatedData = [].concat(_toConsumableArray(storedData), [recentOrderObj]);
                } else {
                  updatedData = [recentOrderObj];
                }

                _context13.prev = 6;
                thresholdTimestamp = moment().subtract(6, "months").valueOf();
                updatedDataAfterTimeValidation = updatedData.filter(function (_data) {
                  var _data$order;

                  var orderTimeStamp = _data === null || _data === void 0 ? void 0 : (_data$order = _data.order) === null || _data$order === void 0 ? void 0 : _data$order.submittedDate;
                  return orderTimeStamp > thresholdTimestamp;
                });
                _context13.next = 11;
                return this.rootStore.platformUtil.saveInLocalStorage("RECENT_ORDER_DETAILS_CLOUD", JSON.stringify(updatedDataAfterTimeValidation));

              case 11:
                _context13.next = 13;
                return (_this$rootStore7 = this.rootStore) === null || _this$rootStore7 === void 0 ? void 0 : (_this$rootStore7$menu = _this$rootStore7.menuList) === null || _this$rootStore7$menu === void 0 ? void 0 : _this$rootStore7$menu.fetchRecentOrdersFromLocalStorage();

              case 13:
                _context13.next = 18;
                break;

              case 15:
                _context13.prev = 15;
                _context13.t0 = _context13["catch"](6);
                console.log("*** catch", _context13.t0);

              case 18:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[6, 15]]);
      }));

      function saveOrderDataInLocalStorage() {
        return _saveOrderDataInLocalStorage.apply(this, arguments);
      }

      return saveOrderDataInLocalStorage;
    }()
  }, {
    key: "checkAndSaveCurbsideOrderDataInLocalStorage",
    value: function () {
      var _checkAndSaveCurbsideOrderDataInLocalStorage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        var _this$rootStore$curbs, curbsideDetails, _this$rootStore$curbs2, curbsideOrderData;

        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                _context14.next = 3;
                return (_this$rootStore$curbs = this.rootStore.curbside) === null || _this$rootStore$curbs === void 0 ? void 0 : _this$rootStore$curbs.checkIfCurbsideEnabled();

              case 3:
                curbsideDetails = _context14.sent;

                if (!curbsideDetails.enabled) {
                  _context14.next = 10;
                  break;
                }

                curbsideOrderData = this.processLastOrderObject();
                _context14.next = 8;
                return this.rootStore.platformUtil.saveInLocalStorage(curbsideDetails.checkReference, JSON.stringify(curbsideOrderData));

              case 8:
                _context14.next = 10;
                return (_this$rootStore$curbs2 = this.rootStore.curbside) === null || _this$rootStore$curbs2 === void 0 ? void 0 : _this$rootStore$curbs2.fetchCurbsideCheckSummary();

              case 10:
                _context14.next = 14;
                break;

              case 12:
                _context14.prev = 12;
                _context14.t0 = _context14["catch"](0);

              case 14:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[0, 12]]);
      }));

      function checkAndSaveCurbsideOrderDataInLocalStorage() {
        return _checkAndSaveCurbsideOrderDataInLocalStorage.apply(this, arguments);
      }

      return checkAndSaveCurbsideOrderDataInLocalStorage;
    }()
  }, {
    key: "orderConfirmationTakeSurveyEvent",
    value: function () {
      var _orderConfirmationTakeSurveyEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(payload) {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                this.analyticsModel.dispatchOrderConfirmationTakeSurvey(payload);

              case 1:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function orderConfirmationTakeSurveyEvent(_x17) {
        return _orderConfirmationTakeSurveyEvent.apply(this, arguments);
      }

      return orderConfirmationTakeSurveyEvent;
    }()
  }, {
    key: "shareText",
    get: function get() {
      var shareTextDetails = this.orderConfirmationModel.getShareTextDetails();
      if (shareTextDetails.orderType === DecodedOrderType.CATERING_DELIVERY) return "Your ".concat(this.rootStore.common.appAttributes.concept.conceptCodeDesc, " ").concat(shareTextDetails.orderType, " Order #").concat(shareTextDetails === null || shareTextDetails === void 0 ? void 0 : shareTextDetails.orderNumber, " \n\n-from-\n").concat(shareTextDetails.restaurantDetails.restName, ", ").concat(shareTextDetails.restaurantDetails.restAddress, ", ").concat(shareTextDetails.restaurantDetails.addressLineTwo, "\n\nReceiving the Order: ").concat(shareTextDetails.name, "\nTotal Paid: ").concat(shareTextDetails.orderTotal, " \n\nFor car-side pickup, please call the restaurant at ").concat(shareTextDetails.restaurantPhone, " upon arrival.");
      return "Your ".concat(this.rootStore.common.appAttributes.concept.conceptCodeDesc, " ").concat(shareTextDetails.orderType, " Order #").concat(shareTextDetails === null || shareTextDetails === void 0 ? void 0 : shareTextDetails.orderNumber, " will be ready:\n\n").concat(shareTextDetails.restaurantDetails.pickupTime, "\n-at-\n").concat(shareTextDetails.restaurantDetails.restName, ", ").concat(shareTextDetails.restaurantDetails.restAddress, ", ").concat(shareTextDetails.restaurantDetails.addressLineTwo, "\n\nPicking up Order: ").concat(shareTextDetails.pickupDetails.pickupByName, "\nTotal Paid: ").concat(shareTextDetails.orderTotal, " \n\nFor car-side pickup, please call the restaurant at ").concat(shareTextDetails.restaurantPhone, " upon arrival.");
    }
  }]);

  return OrderConfirmation;
}(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_restuarantDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_sessionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
})), _class);
export { OrderConfirmation as default };